import React, { useState, useEffect } from 'react';

import { Container, ContainerAgenda, ContainerCalendar, ContainerListAgendamentos, ContainerAviso, ContainerNotas } from './stylesHome';
import { ButtonPadrao } from '../../styles/CommonStyles';

function Home () {


    return (
        <Container>

        </Container>
    );
}

export default Home;
